// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M21 6.58594V23H3V1H15.4141L21 6.58594ZM6 12C5.17157 12 4.5 12.6716 4.5 13.5V18.5C4.5 19.3284 5.17157 20 6 20H8.75V18H6.5V14H8.75V12H6ZM11 12C10.1716 12 9.5 12.6716 9.5 13.5V15.5C9.5 16.3284 10.1716 17 11 17H12V18H9.75V20H12.5C13.3284 20 14 19.3284 14 18.5V16.5C14 15.6716 13.3284 15 12.5 15H11.5V14H13.75V12H11ZM14.5 12V16.4365C14.5 16.7647 14.5809 17.0883 14.7354 17.3779L16.1172 19.9707H17.8828L19.2646 17.3779C19.4191 17.0883 19.5 16.7647 19.5 16.4365V12H17.5V16.4365L17 17.374L16.5 16.4365V12H14.5ZM14.5 7.5H19L14.5 3V7.5Z"}}]};

const FileCsvFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'file-csv-filled',
    ref,
    icon: element,
  },
));

FileCsvFilledIcon.displayName = 'FileCsvFilledIcon';

export default FileCsvFilledIcon;
